import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class DateFormatterService {
  constructor(private dp: DatePipe) {}

  formatDateTime(date: string): string {
    return date ? this.dp.transform(date, 'dd MMM yyyy HH:mm') ?? '' : '';
  }

  formatDate(date: string): string {
    return date ? this.dp.transform(date, 'dd MMM yyyy') ?? '' : '';
  }
}
